import { KNOCK_FAILED } from 'actions/Types';

function setKnockFailed(status) {
  return dispatch => {
    const action = {
      type: KNOCK_FAILED,
      payload: status
    };
    dispatch(action);
  };
}

export default setKnockFailed;
